import * as TypeGraphQL from "type-graphql";
export var SignalPriorityTier;
(function (SignalPriorityTier) {
    SignalPriorityTier["HIGH"] = "HIGH";
    SignalPriorityTier["MEDIUM"] = "MEDIUM";
    SignalPriorityTier["LOW"] = "LOW";
    SignalPriorityTier["DEPRIORITIZED"] = "DEPRIORITIZED";
})(SignalPriorityTier || (SignalPriorityTier = {}));
TypeGraphQL.registerEnumType(SignalPriorityTier, {
    name: "SignalPriorityTier",
    description: undefined,
});
//# sourceMappingURL=SignalPriorityTier.js.map